import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { DepositData } from "./DepositData";

const Deposits = () => {
  document.title = "Users Deposits | mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Users Deposits" />
          <DepositData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Deposits;
